module.exports = __webpack_public_path__ + "img/stage-glow-sw.8621fbbf.png";